import { useCallback, useState } from "react";
import { motion } from "motion/react";
import { useHistory } from "react-router";
import GenericFlyout from "../modal/GenericFlyout";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { useCurrentUser } from "../../functional-components/UserContext";
import LoginForm, { getInitialLoginData } from "../form/LoginForm";
import A from "../A";
import BjelinButton from "../BjelinButton";
import AccountMenu from "../AccountMenu";
import Avatar from "../Avatar";
import CreateUserModal from "../modal/CreateUserModal";
import ForgotPasswordModal from "../modal/ForgotPasswordModal";
import Icon from "../Icon";
import { useUiMessageContext } from "../UIMessages/context";
import { SUCCESS } from "../UIMessages";

const UserDropdown = () => {
  const { displayMessage } = useUiMessageContext();
  const t = useBjelinTranslations();
  const history = useHistory();
  const { authenticated, anonymous, user } = useCurrentUser();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const closeUserMenu = useCallback(() => setShowUserMenu(false), []);
  const toggleUserMenu = useCallback(
    () => setShowUserMenu(showUserMenu => !showUserMenu),
    []
  );
  const toggleForgotPasswordModal = () =>
    setShowForgotPasswordModal(!showForgotPasswordModal);
  const toggleCreateUserModal = () =>
    setShowCreateUserModal(!showCreateUserModal);

  return (
    <>
      <button
        id="user-menu-button"
        title={t("menu.tooltip.user")}
        aria-haspopup="dialog"
        className="nav-link"
        style={{
          backgroundColor: showUserMenu ? "#fff" : "transparent",
          border: 0
        }}
        aria-expanded={showUserMenu}
        onClick={toggleUserMenu}
      >
        {anonymous ? (
          <Icon name="user" className="icon" />
        ) : (
          <Avatar user={user} />
        )}
      </button>
      {!authenticated ? (
        <GenericFlyout
          key="anonymous"
          id={"user-dropdown"}
          isOpen={showUserMenu}
          close={closeUserMenu}
          noCloseBtn
          excludeFromClose="user-menu-button"
          align={"top"}
          width={20}
          ariaLabel={t("log.in")}
        >
          <motion.div
            className={"px-4 py-3"}
            style={{
              background: "#fff",
              height: "100%",
              maxHeight: "100%"
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <h2>{t("log.in")}</h2>
            <LoginForm autoFocusInput initialValues={getInitialLoginData()} />
            <A onClick={toggleForgotPasswordModal}>
              {t("forgot.your.password")}
            </A>
            <div className="dropdown-divider" />
            <h2>{t("new.customer")}?</h2>
            <BjelinButton
              color={"bjelin-green"}
              onClick={toggleCreateUserModal}
            >
              {t("account.create")}
            </BjelinButton>
          </motion.div>
        </GenericFlyout>
      ) : (
        <GenericFlyout
          key="authenticated"
          id={"user-dropdown-auth"}
          isOpen={showUserMenu}
          close={closeUserMenu}
          noCloseBtn
          excludeFromClose="user-menu-button"
          align={"top"}
          width={20}
          ariaLabel={t("account.heading")}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <AccountMenu
              afterLogout={() => {
                history.push("/");
                displayMessage({
                  text: t("log.out.success"),
                  type: SUCCESS
                });
              }}
            />
          </motion.div>
        </GenericFlyout>
      )}
      <ForgotPasswordModal
        isOpen={showForgotPasswordModal}
        toggle={toggleForgotPasswordModal}
      />
      <CreateUserModal
        isOpen={showCreateUserModal}
        toggle={toggleCreateUserModal}
      />
    </>
  );
};

export default UserDropdown;
